import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import GetAppIcon from '@mui/icons-material/GetApp';

import IconButton from '../../common/buttons/IconButton';

import { API_URL } from '../../../services/settings';

const ExportPDFButton = () => {
    const record = useRecordContext();
    const translate = useTranslate();

    return (
        <IconButton icon={<GetAppIcon />} component="a" target="__blank" href={`${API_URL}/invoices/${record?.id}/invoice${record?.number ? `_${record.number}` : ''}.pdf`}>{translate('ra.action.export')}</IconButton>
    );
};

export default ExportPDFButton;